module.exports = __webpack_public_path__ + "static/media/icon_info_cc.f3c013d5.svg";